import { useEffect, useState } from "react";

export default function PersonalNotes({ storageKey }) {
  const [value, setValue] = useState("");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved !== null) setValue(saved);
    } catch { }
  }, [storageKey]);

  useEffect(() => {
    const t = setTimeout(() => {
      try { localStorage.setItem(storageKey, value); } catch { }
    }, 250);
    return () => clearTimeout(t);
  }, [storageKey, value]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, height: "100%" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontSize: 9, letterSpacing: ".16em", textTransform: "uppercase", color: "rgba(100,116,139,.7)", fontFamily: "ui-monospace,monospace" }}>
          Bloc-notes personnel
        </div>
        <span style={{ fontSize: 9, color: "rgba(71,85,105,.5)", fontFamily: "ui-monospace,monospace" }}>
          {value.length} car.
        </span>
      </div>

      {/* Textarea */}
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={"· Codes / pistes\n· Ce que tu dois dire aux autres\n· Hypothèses"}
        style={{
          flex: 1, minHeight: 200, resize: "none",
          borderRadius: 8,
          background: "rgba(0,0,0,.45)",
          border: "1px solid rgba(255,255,255,.07)",
          padding: "10px 12px",
          fontSize: 12, lineHeight: 1.55,
          color: "rgba(226,232,240,.9)",
          fontFamily: "ui-sans-serif,system-ui",
          outline: "none",
        }}
        onFocus={e => { e.target.style.borderColor = "rgba(99,102,241,.4)"; e.target.style.boxShadow = "0 0 0 2px rgba(99,102,241,.12)"; }}
        onBlur={e => { e.target.style.borderColor = "rgba(255,255,255,.07)"; e.target.style.boxShadow = "none"; }}
        className="custom-scrollbar placeholder:text-slate-600"
      />

      {/* Actions */}
      <div style={{ display: "flex", gap: 6 }}>
        <button
          type="button"
          onClick={() => { setValue(""); try { localStorage.removeItem(storageKey); } catch { } }}
          style={{
            flex: 1, padding: "6px 10px", borderRadius: 7,
            border: "1px solid rgba(255,255,255,.08)",
            background: "rgba(255,255,255,.03)",
            color: "rgba(148,163,184,.8)", fontSize: 11,
            cursor: "pointer", transition: "all .15s",
            fontFamily: "ui-sans-serif,system-ui",
          }}
          onMouseEnter={e => e.target.style.background = "rgba(255,255,255,.07)"}
          onMouseLeave={e => e.target.style.background = "rgba(255,255,255,.03)"}
        >
          Effacer
        </button>
        <button
          type="button"
          onClick={() => navigator.clipboard?.writeText(value)}
          style={{
            flex: 1, padding: "6px 10px", borderRadius: 7,
            border: "1px solid rgba(99,102,241,.3)",
            background: "rgba(99,102,241,.12)",
            color: "rgba(165,180,252,.9)", fontSize: 11,
            cursor: "pointer", transition: "all .15s",
            fontFamily: "ui-sans-serif,system-ui",
          }}
          onMouseEnter={e => e.target.style.background = "rgba(99,102,241,.2)"}
          onMouseLeave={e => e.target.style.background = "rgba(99,102,241,.12)"}
        >
          Copier
        </button>
      </div>
    </div>
  );
}